//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.MotionBuilder.js";
import "../Motion/Motion.SelectLink.js";
import "../Motion/Motion.SelectJoint.js";
import "../no/SelectObject.js";
let d=[[[1,"ActionLink",0,"Motion.SelectLink",0],[0,"ActionPoint",1,"Point",0],[0,"Attachment",1,0],[1,"Joint",0,"Motion.SelectJoint",0],[1,"ReactionLink",0,"Motion.SelectLink",0],[0,"ReactionPoint",1,"Point",0]],[],[]];
SPLM.Motion.ConnectorBuilder = class extends SPLM.Motion.MotionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.ConnectorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.ConnectorBuilder.AttachmentType = Object.freeze({
    "Link" : "Link", "SliderJoint" : "SliderJoint", "RevoluteJoint" : "RevoluteJoint", "CylindricalJoint" : "CylindricalJoint"});

SPLM.Motion.ConnectorBuilder.ApplicationDirection = Object.freeze({
    "Bidirectional" : "Bidirectional", "TensionOnly" : "TensionOnly", "CompressionOnly" : "CompressionOnly"});

export default SPLM;